import { render, staticRenderFns } from "./LogDescEmail.vue?vue&type=template&id=37f960c0&scoped=true"
import script from "./LogDescEmail.vue?vue&type=script&lang=js"
export * from "./LogDescEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f960c0",
  null
  
)

export default component.exports